import { Component, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { GpsService } from '../_services/gps.service';
import { GpsDto } from './gps-dto';
import { interval, Subscription } from 'rxjs';
import { SubscribeService } from '../_services/subscribe.service';

@Component({
  selector: 'app-gps',
  templateUrl: './gps.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./gps.component.css']
})
export class GpsComponent {
  mySubscription: Subscription;

  constructor(
    private gpservice: GpsService,
    private _subscribeService: SubscribeService,
    private cdr: ChangeDetectorRef
  ) {
    const someArray: { key: string; lat: string; long: string }[] = [
      { key: 'Aldi', lat: '59.44444', long: '5.666' },
      { key: 'Kruidvat', lat: '52.29982', long: '5.61866' },
      { key: 'Gamma', lat: '52.29807647147858', long: '5.618669718967602' },
      { key: 'Gelderblom', lat: '52.30296801141909', long: '5.61868582821112' },
    ];

    this.shoplocation = someArray.find(({ key }) => key === this.selectedShop);

    this.mySubscription = interval(15000).subscribe(() => {
      this.time = Date.now();
      this.getLocation();
    });
  }

  result: GpsDto;
  distance: number;
  message: string;
  shoplocation: any;
  observablevar: any;
  latitude: number;
  longitude: number;
  time: number;
  selectedShop: string = 'Gamma';

  findShop(shop) {
    return shop.key === 'Aldi';
  }

  getMessage(): string {
    this.message = 'U bent verder dan 500 meter verwijderd van de bestemming (' + this.distance + ')';
    if (this.distance < 500) {
      if (!this._subscribeService.notificationSend) {
        this._subscribeService.notificationSend = true;
        this._subscribeService.sendNotification('U bent in de buurt: met ' + this._subscribeService.notificationSend);
      }
      this.message = 'U bent in de buurt';
    } else {
      this._subscribeService.notificationSend = false;
    }
    return this.message;
  }

  setShop(shop: string) {
    this.selectedShop = shop;
  }

  getLocation(): any {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.longitude = position.coords.longitude;
        this.latitude = position.coords.latitude;
        this.gpservice.getDistance(
          this.latitude, this.longitude,
          this.shoplocation.lat, this.shoplocation.long
        ).subscribe(data => {
          this.result = JSON.parse(data);
          this.distance = this.result.features[0].properties.summary.distance;
          this.cdr.detectChanges();
        });
      });
    } else {
      console.error('No support for geolocation');
    }
  }
}
